import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface StatsTile {
    title: string;
    value: string;
    icon: React.ReactElement;
    color: string;
    bgColor: string;
    borderColor: string;
}

interface StatsCardsProps {
    tiles: StatsTile[];
}

function StatsCards({ tiles }: StatsCardsProps) {
    const theme = useTheme();

    return (
        <Box>
            {/* Desktop Grid */}
            <Box
                sx={{
                    display: { xs: 'none', md: 'grid' },
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: 1.5,
                    mb: 3,
                }}
            >
                {tiles.map((tile, index) => (
                    <Box
                        key={index}
                        sx={{
                            p: 1.5,
                            borderRadius: '16px 2px',
                            backgroundColor: tile.bgColor,
                            border: `1px solid ${tile.borderColor}`,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            minHeight: 90,
                        }}
                    >
                        <Box sx={{ color: tile.color, m: 0 }}>{React.cloneElement(tile.icon, { size: 24 })}</Box>
                        <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, color: theme.palette.text.primary, mb: 0.25, fontSize: '1.1rem' }}
                        >
                            {tile.value}
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{ color: theme.palette.text.secondary, fontWeight: 500, fontSize: '0.7rem' }}
                        >
                            {tile.title}
                        </Typography>
                    </Box>
                ))}
            </Box>

            {/* Mobile Compact Row */}
            <Box
                sx={{
                    display: { xs: 'flex', md: 'none' },
                    gap: 1.5,
                    mb: 3,
                    justifyContent: 'space-between',
                }}
            >
                {tiles.map((tile, index) => (
                    <Box
                        key={index}
                        sx={{
                            flex: 1,
                            p: 1.5,
                            borderRadius: '12px 2px',
                            backgroundColor: tile.bgColor,
                            border: `1px solid ${tile.borderColor}`,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            minHeight: 80,
                        }}
                    >
                        <Box sx={{ color: tile.color, m: 0 }}>{React.cloneElement(tile.icon, { size: 18 })}</Box>
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                color: theme.palette.text.primary,
                                fontSize: '0.95rem',
                                lineHeight: 1.1,
                                mb: 0.25,
                            }}
                        >
                            {tile.value}
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{
                                color: theme.palette.text.secondary,
                                fontWeight: 500,
                                fontSize: '0.7rem',
                                lineHeight: 1.1,
                            }}
                        >
                            {tile.title}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default StatsCards;
